import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import SignaturePad from 'signature_pad';
import { Text2Sign, svgToPng } from 'src/app/public/auto-generate-signatureFromName';
import { FileHandle } from 'src/app/shared/directives/dragDrop.directive';
import fonts from '../../../../public/auto-generate-signatureFromName/fonts.json';
import { AppService } from 'src/@core/services/app.service';
import { NotificationService } from 'src/@core/services/notification.service';
import { JobService } from 'src/@core/services/job/job.service';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'hour4u-admin-sign-contract-popup',
  templateUrl: './sign-contract-popup.component.html',
  styleUrls: ['./sign-contract-popup.component.scss']
})
export class SignContractPopupComponent implements OnInit {
  legalName: string = "";
  signContractForm: FormGroup;
  isLoading: boolean = false;
  diameter = 40;
  loaderColor: string;
  mode = 'indeterminate';
  @Output() enabledSignedContractBtn = new EventEmitter();
  sig: SignaturePad;
  selectedSignatureOption: any = null;
  showSavedSignature: boolean = false;
  signaturePersonName: string = null;
  @ViewChild("drawableSignatureCanvas", { static: true }) drawableSignatureCanvas: ElementRef;
  @ViewChild("cameraCapturedImageCanvas", { static: true }) cameraCapturedImageCanvas: ElementRef;
  @ViewChild('cameraLivestream', { static: true }) cameraLivestream;
  files: FileHandle[] = [];
  showCaptureImg: boolean = false;
  signatureCapturedByCamera: boolean = false;
  viewUploadedSignature: any = null;
  signatureList: any[] = [];
  signatureNameUpdate = new Subject<string>();
  selectedSignature: number = -1;
  check: boolean = false;
  videoElement: HTMLVideoElement;
  signContractSignature: any = null;
  signaturePad: SignaturePad;
  selectedSignatureImg: any = null;
  selectAutoGeneratedSignatureImg: any = null;
  signatureFileObj: any = null;
  selectedFileImage: any = null;
  uploadedSignature: any = null;
  profile = this.appService.getCurrentAccount();
  @Input() step: number = 1;
  @Input() selectedData?: any = null;
  comingFromQuote: boolean = false;
  selectedDocument: any = null;
  documentUrl: any = "";

  constructor(
    public dialogRef: MatDialogRef<SignContractPopupComponent>,
    // @Inject(MAT_DIALOG_DATA) public selectedData: any,
    private _fb: FormBuilder,
    private appService: AppService,
    private notify: NotificationService,
    private jobService: JobService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    // Update signature img on name change
    this.signatureNameUpdate.pipe(
      debounceTime(400),
      distinctUntilChanged())
      .subscribe(value => {
        if (value) {
          const text2sign = new Text2Sign();
          const text2sign1 = new Text2Sign();
          this.signatureList = [];

          text2sign.generateSignature(this.signaturePersonName, 50, { url: fonts.Satisfaction, name: 'Satisfaction' }, 'black');
          const svgData = text2sign.getSVGdata();
          svgToPng(svgData, (img) => {
            this.signatureList.push(img)
          })
          text2sign1.generateSignature(this.signaturePersonName, 50, { url: fonts.Autography, name: 'Autography' }, 'black');
          const svgData1 = text2sign1.getSVGdata();
          svgToPng(svgData1, (img) => {
            this.signatureList.push(img)
          })
        } else {
          this.signatureList = [];
        }
      });
  }

  ngOnInit() {
    this.signContractForm = this._fb.group({
      legalName: [null, [Validators.required]],
      selectedDuration: [],
      check: [false]
    });
    this.selectSignatureOption('drawSignature');
    this.comingFromQuote = false;
    if (this.selectedData && this.selectedData.selectedQuote) {
      this.comingFromQuote = true;
    }
  }

  // selected signature capture option
  selectSignatureOption(option) {
    this.clearSignature();
    this.selectedSignatureOption = option;
    this.signaturePersonName = null;
    this.signaturePersonName = this.profile.user.userMeta.name;
    this.signatureNameUpdate.next(this.signaturePersonName);
    if (option == 'drawSignature') {
      if (this.drawableSignatureCanvas)
        this.signaturePad = new SignaturePad(this.drawableSignatureCanvas.nativeElement);

      // Add event listeners for detecting when drawing ends
      // this.drawableSignatureCanvas.nativeElement.addEventListener('mouseup', this.onSignatureEnd.bind(this));
      // this.drawableSignatureCanvas.nativeElement.addEventListener('touchend', this.onSignatureEnd.bind(this));
      // this.drawableSignatureCanvas.nativeElement.addEventListener('pointerup', this.onSignatureEnd.bind(this));

      window.addEventListener('mouseup', this.onSignatureEnd.bind(this));
      window.addEventListener('touchend', this.onSignatureEnd.bind(this));
      window.addEventListener('pointerup', this.onSignatureEnd.bind(this));
    }
    if (option == 'signatureSelect') {
      this.selectAutoGeneratedImg(this.signatureList[0], false);
    }
  }

  onSignatureEnd() {
    if (!this.signaturePad.isEmpty()) {
      const base64Signature = this.signaturePad.toDataURL('image/png');
      // this.selectAutoGeneratedSignatureImg = base64Signature;
      this.emitEvent();
    }
  }

  // Clear all capture and uploaded doc field
  clearSignature() {
    if (this.signaturePad) {
      if (!this.signaturePad.isEmpty())
        this.signaturePad.clear();
    }
    this.showCaptureImg = false;
    this.selectAutoGeneratedSignatureImg = null;
    this.files = [];
    this.signatureCapturedByCamera = false;
    this.selectedFileImage = null;
    this.uploadedSignature = null;
    this.signatureFileObj = null;
    this.emitEvent();
  }

  // selected files for pancard , gst and signature
  selectedFile(event, field) {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (field == 'signature') {
        this.viewUploadedSignature = reader.result;
        this.selectedFileImage = reader.result;
        this.signatureFileObj = file;
        this.emitEvent();
      }
    };
  }

  // file drag&drop file obj get
  filesDropped(files: FileHandle[]): void {
    this.files = files;
  }

  // capture signature with camera
  takePicture() {
    const canvasElement = this.cameraCapturedImageCanvas.nativeElement;
    const context = canvasElement.getContext('2d');
    context.drawImage(this.videoElement, 0, 0, canvasElement.width, canvasElement.height);
    this.signatureCapturedByCamera = true;
    const base64Image = canvasElement.toDataURL('image/png');
    this.selectAutoGeneratedSignatureImg = base64Image;
    this.emitEvent();
  }

  // clicked img by camera
  captureImage() {
    this.showCaptureImg = true;
    this.videoElement = this.cameraLivestream.nativeElement;
    navigator.mediaDevices
      .getUserMedia({
        video: { facingMode: 'environment' },
      })
      .then(stream => {
        this.videoElement.srcObject = stream;
      });
  }

  // select auto generated img
  selectAutoGeneratedImg(signature, emitCall: boolean = false) {
    this.clearSignature();
    this.selectAutoGeneratedSignatureImg = signature;
    if (emitCall) {
      this.emitEvent();
    }
  }

  // convert Img to blob file
  b64toBlob(b64Data, contentType = '', sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  next() {
    this.step = this.step + 1;
  }

  convertedBase64PDFDoc(base64) {
    this.selectedDocument = base64;
  }

  // after adding signature click on next
  // confirmSignature() {
  //   console.log(this.signaturePad.toDataURL(), this.selectAutoGeneratedSignatureImg, this.signatureFileObj)
  //   this.selectedSignatureImg = null;
  //   let pad = `data:image/png;base64,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`;
  //   console.log(this.signaturePad)
  //   if (this.signaturePad.toDataURL()) {
  //     if (this.signaturePad.toDataURL() != pad) {
  //       this.selectedSignatureImg = this.b64toBlob(this.signaturePad.toDataURL().split('base64,')[1], `image/${this.signaturePad.toDataURL().split('base64,')[0].split('data:image/')[1].replace(';', '')}`);
  //     }
  //   }
  //   if (this.selectAutoGeneratedSignatureImg) {
  //     this.selectedSignatureImg = this.b64toBlob(this.selectAutoGeneratedSignatureImg.split('base64,')[1], `image/${this.selectAutoGeneratedSignatureImg.split('base64,')[0].split('data:image/')[1].replace(';', '')}`);
  //   }
  //   if (this.signatureFileObj) {
  //     this.selectedSignatureImg = this.signatureFileObj;
  //   }
  //   console.log(this.selectedSignatureImg)

  //   if (this.selectedSignatureImg) {
  //     if (this.selectedData && this.selectedData.selectedQuote && this.selectedData.selectedQuote.quoteStatusChangeCalled) {
  //       // attach signature for quote approval time (Enterprise signature)
  //       if (this.step == 1) {
  //         this.jobService.uploadSignatureImages(this.selectedSignatureImg).subscribe(res => {
  //           this.selectedData.selectedProject.enterpriseSignature = environment.image_url + res.key;
  //           this.updateQuotation();
  //           return;
  //         })
  //       }
  //       if (this.step == 2) {
  //         // this.jobService.uploadSignatureImages(this.selectedDocument).subscribe(res => {
  //         //   this.selectedData.selectedProject.documentUrl = environment.image_url + res.key;
  //         this.uploadSignedDocument();
  //         //   return;
  //         // })
  //       }
  //     } else {
  //       // attach signature for project create time (Agency signature)
  //       this.jobService.uploadSignatureImages(this.selectedSignatureImg).subscribe(res => {
  //         this.selectedData.agencySignature = environment.image_url + res.key;
  //         const dateString = new Date();
  //         const dateObj = new Date(dateString);
  //         const year = dateObj.getFullYear();
  //         const month = dateObj.getMonth() + 1;
  //         const day = dateObj.getDate();
  //         this.isLoading = true;
  //         const resultArray: number[] = [year, month, day];
  //         this.selectedData.agencySignatureUploadedDate = resultArray;
  //         this.saveProject();
  //       })
  //     }
  //   } else {
  //     this.notify.showMessage("Please do signature!", 3000);
  //   }
  // }

  updateQuotation(status?: string) {
    const dateString = this.selectedData.selectedQuote.quoteConditions.quoteValidity;
    const dateObj = new Date(dateString);
    const year = dateObj.getFullYear();
    const month = dateObj.getMonth() + 1;
    const day = dateObj.getDate();
    this.isLoading = true;
    const resultArray: number[] = [year, month, day];

    const dateString1 = new Date();
    const dateObj1 = new Date(dateString1);
    const year1 = dateObj1.getFullYear();
    const month1 = dateObj1.getMonth() + 1;
    const day1 = dateObj1.getDate();
    this.isLoading = true;
    const resultArray1: number[] = [year1, month1, day1];
    let obj = {
      "id": this.selectedData.selectedQuote.id,
      "entityId": this.profile.entity.id,
      "jobId": this.selectedData.selectedProject.id,
      "assignmentId": this.selectedData.selectedProject.assignmentId,
      "status": status ? status : this.selectedData.selectedQuote.status,
      "jobRateCards": this.selectedData.selectedQuote.jobRateCards,
      "variableJobRateCards": this.selectedData.selectedQuote.variableJobRateCards,
      "quoteConditions": {
        "expiryDate": this.selectedData.selectedQuote.quoteConditions.expiryDate,
        "quoteValidity": resultArray,
        "paymentTerms": this.selectedData.selectedQuote.quoteConditions.paymentTerms,
        "addtional": this.selectedData.selectedQuote.quoteConditions.additionalTermsAndConditions
      },
      "attachments": this.selectedData.selectedQuote.attachments,
      "enterpriseSignature": this.selectedData.selectedProject.enterpriseSignature,
      "agencySignature": this.selectedData.selectedQuote.agencySignature,
      "enterpriseSignatureDate": resultArray1
    }
    this.jobService.updateQuotation(obj).subscribe(res => {
      if (res) {
        // this.notify.showMessage('Quotation update successfully!', 2000);
        if (this.step == 1) {
          setTimeout(() => {
            this.isLoading = false;
            this.next();
            this.fetchSigedDocument();
          }, 100);
        }
        if (this.step == 2) {
          this.isLoading = false;
          this.notify.showMessage('Signed document successfully!', 2000);
          this.dialogRef.close(true);
        }
      }
    }, (err => {
      console.log(err)
      this.isLoading = false;
    }))
  }

  saveProject() {
    this.isLoading = true;
    if (this.selectedData.id) {
      // Update existing project
      this.jobService.update(this.selectedData.id, this.selectedData).subscribe(
        (data) => {
          this.isLoading = false;
          this.notify.showMessage("Project updated successfully!", 2000);
          this.dialogRef.close(true);
          this.router.navigate(['/job'], { relativeTo: this.route });
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.notify.showMessage("Error while updating project!", 2000);
        }
      );
    } else {
      // Create new project
      this.jobService.create(this.selectedData).subscribe(
        (data) => {
          this.isLoading = false;
          this.notify.showMessage("Project created successfully!", 2000);
          this.dialogRef.close(true);
          this.router.navigate(['/job'], { relativeTo: this.route });
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.notify.showMessage("Error while creating project!", 2000);
        }
      );
    }
  }

  uploadSignedDocument() {
    this.isLoading = true;
    if (this.documentUrl) {
      let obj = {
        "issuerEntityId": this.selectedData.selectedQuote.agencyDetails.id,
        "subjectEntityId": this.selectedData.selectedQuote.enterpriseDetails.id,
        "documentUrl": this.documentUrl,
      }
      this.jobService.uploadSignedContract(obj).subscribe((res) => {
        this.isLoading = false;
        this.updateQuotation("ACCEPTED");
      }, (err => {
        console.log(err)
        this.isLoading = false;
        this.notify.showMessage("Something went wrong!", 2000);
      }))
    } else {
      this.isLoading = false;
      this.notify.showMessage("Signed document not generated yet!", 2000);
    }
  }

  back() {
    this.step = this.step - 1;
  }

  fetchSigedDocument() {
    this.isLoading = true;
    this.jobService.fetchSignedDocument(this.selectedData.selectedQuote.id).subscribe(res => {
      this.isLoading = false;
      if (res && res.key) {
        this.documentUrl = res.key;
      }
    }, (err => {
      console.log(err)
      this.isLoading = false;
      this.notify.showMessage("Signed document not generated!", 2000);
    }))
  }


  emitEvent() {
    // console.log(this.signaturePad.toDataURL(), this.selectAutoGeneratedSignatureImg, this.signatureFileObj)
    this.selectedSignatureImg = null;
    let pad = `data:image/png;base64,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`;
    if (this.signaturePad && this.signaturePad.toDataURL()) {
      if (this.signaturePad.toDataURL() != pad) {
        this.selectedSignatureImg = this.b64toBlob(this.signaturePad.toDataURL().split('base64,')[1], `image/${this.signaturePad.toDataURL().split('base64,')[0].split('data:image/')[1].replace(';', '')}`);
      }
    }
    if (this.selectAutoGeneratedSignatureImg) {
      this.selectedSignatureImg = this.b64toBlob(this.selectAutoGeneratedSignatureImg.split('base64,')[1], `image/${this.selectAutoGeneratedSignatureImg.split('base64,')[0].split('data:image/')[1].replace(';', '')}`);
    }
    if (this.signatureFileObj) {
      this.selectedSignatureImg = this.signatureFileObj;
    }


    // let meta_data={
    //   agreementDate : this.selectedQuote.createdOn,
    //   companyName : this.profile.user.userMeta.name,
    //   companyAdrress : null,
    //   commencementDate : moment(new Date()).format('MM-DD-YYYY'),
    //   flatAmount : this.getFinalTotalAmount() * 1.18,
    //   advanceAmount : 0,
    //   contractorCompanyName : "HOUR4U TECHNOLOGIES PRIVATE LIMITED",
    //   agencySignatureUploadedDate : this.selectedQuote.agencySignatureUploadedDate,
    //   contractorName : "",
    //   agencySignature : this.selectedQuote.agencySignature,
    //   clientName : this.profile.user.userMeta.name,
    //   enterpriseSignatureDate : this.selectedQuote.enterpriseSignatureDate,
    //   enterpriseSignature : this.selectedQuote.enterpriseSignature,
    //  }

    if (this.selectedSignatureImg) {
      let obj = {
        step: this.step,
        check: this.check,
        selectedSignatureImg: this.selectedSignatureImg,
        // meta_data : meta_data
      }
      this.enabledSignedContractBtn.emit(obj);
    }
  }

  ngOnDestroy() {
    // Clean up event listeners
    this.drawableSignatureCanvas.nativeElement.removeEventListener('mouseup', this.onSignatureEnd.bind(this));
    this.drawableSignatureCanvas.nativeElement.removeEventListener('touchend', this.onSignatureEnd.bind(this));
    this.drawableSignatureCanvas.nativeElement.removeEventListener('pointerup', this.onSignatureEnd.bind(this));
  }
}
